import { createCustomerPortalSession } from "@/api/privateRequests/stripe/createCustomerPortalSession";
import { mixpanelTrack } from "@/events/mixpanelTrack";
import { cn } from "@/lib/utils";
import { Trans } from "@repo/shared/i18n";

export const PastDueBanner = () => {
  return (
    <div
      className={cn(
        "flex flex-row justify-center items-center pl-2 text-sm desktop:text-sm bg-red-700 text-white sticky top-0 w-full z-40 cursor-pointer h-10 touch-device:h-9 transition-colors",
      )}
      onClick={() => {
        createCustomerPortalSession();
        mixpanelTrack("past_due_banner_clicked");
      }}
    >
      <div className="flex flex-row justify-between w-full text-center">
        <div />
        <div className="my-auto flex items-center gap-2 overflow-hidden mx-auto">
          <span className="hidden mobile:inline truncate">
            <Trans
              ns="subscription"
              i18nKey="pastDueBanner.long"
              components={{ b: <span className="font-bold underline" /> }}
            />
          </span>
          <span className="mobile:hidden truncate text-xs">
            <Trans
              ns="subscription"
              i18nKey="pastDueBanner.short"
              components={{ b: <span className="font-bold underline" /> }}
            />
          </span>
        </div>
      </div>
    </div>
  );
};
